import LockIcon from './component'

export default LockIcon
